import { categories } from "@/mocks/platforms";

interface CategoryGridProps {
  onSelect: (value: string) => void;
}

export default function CategoryGrid({ onSelect }: CategoryGridProps) {
  const items = categories.filter((c) => c.id !== "all");

  return (
    <section id="category" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">Categories</span>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl">按主题找你的吃瓜圈子</h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            总榜看热闹，分类榜才对味。选一个你常泡的方向，直接跳到对应的榜单区间，剩下的交给热度排序。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => {
                onSelect(cat.id);
                const target = document.getElementById("rank");
                if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className="text-left group rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between">
                <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{cat.count} 个平台</span>
              </div>
              <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">{cat.name}榜</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-600 group-hover:gap-2.5 transition-all">
                查看该分类榜
                <i className="ri-arrow-right-line"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}